import React from "react";
import styled from "styled-components";
import Section from "./Section";

function Home() {
  return (
    <Container>
      <Section
        id="aa"
        title="Computer Model 001"
        description="Created by Technology Campany"
        image="pc6.jpeg"
      />
      <Section
        id="bb"
        title="Flower Art 001"
        description="Created by Flower Artist"
        image="flower.jpeg"
      />
      <Section
        id="cc"
        title="Coffee Menu 001"
        description="Created by Coffee Shop"
        image="coffee.jpeg"
      />
    </Container>
  );
}

export default Home;

const Container = styled.div`
  /* border: 5px solid red; */
  height: 100vh;
`;
